<template>
    <div class="info-dialog">
        <div class="icon"><i class="el-icon-circle-check"></i></div>
        <h3>{{$t('transfer.info_dialog.application_number')}}</h3>
        <h2 class="code" test_id="tradeaccount_orderId_info">{{params.orderId}}</h2>
        <p>{{$t('transfer.info_dialog.reminder')}}</p>
        <div class="confirm">
            <el-button type="primary" @click="contiuneFn" test_id= "btn_continue">{{$t('common.contiune')}}</el-button>
        </div>

    </div>
</template>
<script>
export default {
  props: ['params', 'contiune', 'refresh'],
  data () {
    return {}
  },
  methods: {
    contiuneFn () {
      this.$emit('closeFun', false)
    },
    getKey (key) {
      console.log(key)
      let items = this.$t('common.preview_dialog')
      return items[key]
    }
  }
}
</script>
<style lang="scss">
.info-dialog{
    text-align: center;
    color: #24282d;
    .icon{
        color: #fec000;
        font-size: 100px;
        text-align: center;
    }
    .code{
        margin: 40px auto 20px;
        padding: 10px;
        background: #f3f4f6;
        width: 85%;
        font-weight: 600;
        letter-spacing: 4px;
    }
    p{
        font-family: Muli-Regular;
        color: #7D7D7D;
        font-size: 14px;
    }
    .el-button--primary{
        color: #192b57
    }
    .confirm{
        .el-button {
      width: 200px;
      max-width: 248.9px;
      height: 56px;
    }
    }
}
</style>
